import { combineReducers } from "@reduxjs/toolkit";
import loginReducer from "./slice/login-slice";
import assessmentReducer from "./slice/assessment-slice";
import historyReducer from "./slice/history-slice";
import phiReducer from "./slice/phi-slice";
import patientDetailReducer from "./slice/patient-detail-slice";
import consultationReducer from "./slice/consultation-slice";
import appointmentReducer from "./slice/appointment-slice";
import videoConsultationReducer from "./slice/videoConsultation-slice";
import careAdminReducer from "./slice/care-admin-slice";
// import connectionReducer from "./slice/connection-check-slice";
import tabsReducer from "./slice/tabs-slice";
import breadCrumbReducer from "./slice/breadcrumb-slice";
import dashboardReducer from "./slice/dashboard-slice";
import MedicineSlice from "./slice/Medicine-slice";
import aiChatReducer from "./slice/aichat-slice";
import ticketListFilterReducer from "./slice/ticketlistFilter-slice";
import planReducer from "./slice/plan-slice";
import planstatisticsReducer from "./slice/planStatistics-slice";
import quizReducer from "./slice/quiz-slice";
import medicaltestReducer from "./slice/medicaltest-slice";
import couponListFilterReducer from "./slice/couponslistFilter-slice";
import doctorfilterReducer from "./slice/doctorfilter-slice";
import offlinePatientReducer from "./slice/offlinePatient-slice";
import urlHistoryReducer from "./slice/url-history-slice";
const appReducer = combineReducers({
  loginReducer,
  assessmentReducer,
  historyReducer,
  planReducer,
  planstatisticsReducer,
  phiReducer,
  patientDetailReducer,
  consultationReducer,
  appointmentReducer,
  videoConsultationReducer,
  careAdminReducer,
  // connectionReducer,
  tabsReducer,
  breadCrumbReducer,
  dashboardReducer,
  ticketListFilterReducer,
  MedicineSlice,
  quizReducer,
  aiChatReducer,
  medicaltestReducer,
  couponListFilterReducer,
  doctorfilterReducer,
  offlinePatientReducer,
  urlHistoryReducer,
  
});
const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    // localstorage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};



export default rootReducer;
